<crm-contact-association-panel [id]="id()" [name]="name()" [objectType]="objectType()"></crm-contact-association-panel>
